import { createAsyncThunk } from '@reduxjs/toolkit';
import apiConfig from 'constants/apiConfig';
import { fetchInvites } from 'services/api/invite';
import { ERROR } from 'types';
import { CampaignInvite, GlobalInvitesFilters, GlobalInvitesSlice } from 'types/invite';
import { generateUniqueKey, getErrorMessage, isFresh } from 'utils/helpers';

export const INVITES_FILTER_KEY_EXCLUDES = ['page'];

export const buildInvitesParams = (filters: GlobalInvitesFilters) =>
    Object.fromEntries(
        Object.entries(filters).filter(
            ([, value]) => value !== '' && value !== 'all' && value !== undefined && value !== null
        )
    );

export const fetchInvitesThunk = createAsyncThunk<
    {
        count: number;
        items: CampaignInvite[];
        filters: GlobalInvitesFilters;
        filterId: string;
    },
    { filters: GlobalInvitesFilters; force?: boolean },
    { rejectValue: string }
>('invites/list', async ({ filters, force }, { getState, rejectWithValue }) => {
    try {
        const STALE_TIME = apiConfig.FETCH_INVITES.staleTime;
        const filterId = generateUniqueKey(filters, INVITES_FILTER_KEY_EXCLUDES);
        const state = getState() as { invites: GlobalInvitesSlice };
        const cachedList = state.invites?.filtered_lists?.[filterId];

        if (
            filters.page === 1 &&
            !force &&
            cachedList &&
            !cachedList.expired &&
            isFresh(cachedList.last_fetched_at, STALE_TIME)
        ) {
            return rejectWithValue(ERROR.CACHED);
        }

        const { count, items = [] } = await fetchInvites(buildInvitesParams(filters));

        return { count, items, filters, filterId };
    } catch (error) {
        return rejectWithValue(getErrorMessage(error, 'Failed to fetch invites'));
    }
});
